<template>
  <pie-chart :donut="true" :data="chartDataItems" :colors="colors" height=530px style="border-bottom: 2px solid #297286; border-right: 2px solid #297286;"></pie-chart>
</template>

<script>

import { STORE_CONSTANTS } from '@/common/store.constants';
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      STORE_CONSTANTS,
      chartData: [
        ["COMPLETED", 0],
        ["SUSPECT", 0],
        ["VALID", 0],
        ["UNKNOWN", 0],
        ["UNDER REVIEW", 0],
        ["FALSIFIED", 0],
      ]
    };
  },
  props: {
    colors: Array,
  },
  computed: {
    chartDataItems: function () {
			return this.chartData;
		},
    ...mapGetters("dailyTasks", [
			"getStaffDailyTaskList",
		]),
  },
  methods: {
    prepareChartData(data) {
      let myChartData = [
        ["COMPLETED", 0],
        ["SUSPECT", 0],
        ["VALID", 0],
        ["UNKNOWN", 0],
        ["UNDER REVIEW", 0],
        ["FALSIFIED", 0],
        ["NO DATA", 0],
        ["UPDATED", 0]
      ];

      if(data) {
          let suspectTaskCount;
          let validTaskCount;
          let underReviewTaskCount;
          let completedTaskCount;
          let unKnownTaskCount;
          let falsifiedTaskCount;
          let noDataTaskCount;
          let upDatedTaskCount;

          console.log('CreateStatusSummaryChart this.allTasks', data)

          suspectTaskCount = data.filter((feature) => {
              return feature.taskStatus === "SUSPECT";
          }).length;

          validTaskCount = data.filter((feature) => {
              return feature.taskStatus === "VALID";
          }).length;

          underReviewTaskCount = data.filter((feature) => {
              return feature.taskStatus === "UNDER_REVIEW";
          }).length;

          completedTaskCount = data.filter((feature) => {
              return feature.taskStatus === "COMPLETED";
          }).length;

          unKnownTaskCount = data.filter((feature) => {
              return feature.taskStatus === "UNKNOWN";
          }).length;

          falsifiedTaskCount = data.filter((feature) => {
              return feature.taskStatus === "FALSIFIED";
          }).length;

          noDataTaskCount = data.filter((feature) => {
              return feature.taskStatus === "NO_DATA";
          }).length;

          upDatedTaskCount = data.filter((feature) => {
              return feature.taskStatus === "UPDATED";
          }).length;

          myChartData = [
              ["COMPLETED", completedTaskCount],
              ["SUSPECT", suspectTaskCount],
              ["VALID", validTaskCount],
              ["UNKNOWN", unKnownTaskCount],
              ["UNDER REVIEW", underReviewTaskCount],
              ["FALSIFIED", falsifiedTaskCount],
              ["NO DATA", noDataTaskCount],
              ["UPDATED", upDatedTaskCount]
          ];
      }

      return myChartData;
    }
  },
  mounted () {
    this.chartData = this.prepareChartData(this.getStaffDailyTaskList);

    const me = this;  // scoped this as in the component
    me.unsubscribe = me.$store.subscribe((mutation, state) => {
      if(mutation.type === me.STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITH_NAMESPACE.SET_STAFF_DAILY_TASKS) {
        me.chartData = me.prepareChartData(state.dailyTasks.staffDaily.tasks);
      }
    });
  },
  beforeDestroy() {
    if(this.unsubscribe) {
        this.unsubscribe();
    }
  }
};
</script>

<style>
</style>
